import VueRouter from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from '../store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';

const routes = [...dashboard.routes];

export const router = new VueRouter({ mode: 'history', routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

export const validateAuthenticateRoutePermission = (to, next, { getters }) => {
  const { isLoggedIn, getCurrentUser: user } = getters;

  if (!isLoggedIn) {
    window.location = '/app/login';
    return '/app/login';
  }

  if (!to.name) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, getters.getCurrentUser);
  if (!nextRoute) return next();

  // When a route is not accessible we fall back to `defaultRedirectPage`. If that
  // fallback resolves to the route we are already on, redirecting again would spin
  // the router forever and freeze the tab. Let the navigation through instead, so
  // the app still boots and the user can reach whatever they do have access to.
  const nextPath = frontendURL(nextRoute);
  if (nextPath === to.path) return next();

  return next(nextPath);
};

export const initalizeRouter = () => {
  const MAX_AUTH_WAIT_MS = 15_000; // timeout — prevents indefinite tela preta

  const userAuthentication = store.dispatch('setUser');
  const authWithTimeout = Promise.race([
    userAuthentication,
    new Promise(resolve => setTimeout(resolve, MAX_AUTH_WAIT_MS)),
  ]);

  router.beforeEach((to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    authWithTimeout
      .then(() => {
        return validateAuthenticateRoutePermission(to, next, store);
      })
      // Se setUser rejeitar (token inválido, rede falhando), o race
      // propaga a rejeição e o .then nunca executa — o router trava.
      // Chamar o validador mesmo em caso de erro para que next() seja
      // invocado e o usuário seja redirecionado ao login.
      .catch(() => {
        return validateAuthenticateRoutePermission(to, next, store);
      });
  });
};

export default router;
